module.exports = __webpack_public_path__ + "media/beep.ff3ed4e6.mp3";